import { environment } from './../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BlacklistPreCandidatoComponent } from '../pages/gestor/parametrizacoes/blacklistprecandidato/blacklistprecandidato.component';
import { Blacklist } from '../models/blacklist.model';

@Injectable({
    providedIn: 'root'
})

export class BlacklistCandidaturaService {
    blacklist: BlacklistPreCandidatoComponent;
    configHeader: { headers: { Authorization: any; }; };
    constructor(
        private http: HttpClient
    ) { }

    public getBlackListByCandidaturaId(token: any, candidaturaId: number) {
        return new Promise((resolve, reject) => {
            this.configHeader = { headers: { 'Authorization': token } }
            this.http.get(`${environment.url_api}/candidaturas/${candidaturaId}/blacklist`, this.configHeader).subscribe(
                payload => {
                    resolve(payload)
                }, err => {
                    reject(err.error.message);
                })
        })
    }

    public atualizaLoginNaBlacklist(token: any, login: Blacklist, loginId: number) {
        return new Promise((resolve, reject) => {
            this.configHeader = { headers: { 'Authorization': token } }
            this.http.put(`${environment.url_api}/blacklistcandidatura/${loginId}`, login, this.configHeader).subscribe(
                payload => {
                    resolve(payload)
                }, err => {
                    reject(err.error.message);
                })
        })
    }

    public deletaLoginNaBlacklist(token: any, blacklistId: number) {
        return new Promise((resolve, reject) => {
            this.configHeader = { headers: { 'Authorization': token } }
            this.http.delete(`${environment.url_api}/blacklistcandidatura/${blacklistId}`, this.configHeader).subscribe(
                payload => {
                    resolve(payload)
                }, err => {
                    reject(err.error.message);
                })
        })
    }

    public inserirLoginNaBlacklist(token: any, login: Blacklist) {
        return new Promise((resolve, reject) => {
            this.configHeader = { headers: { 'Authorization': token } }
            this.http.post(`${environment.url_api}/blacklistcandidatura`, login, this.configHeader).subscribe(
                payload => {
                    resolve(payload)
                }, err => {
                    reject(err.error.message);
                })
        })
    }

    public inserirLoginsNaBlackListEmMassa(token: any, listaLogin: any) {
        return new Promise((resolve, reject) => {
            this.configHeader = { headers: { 'Authorization': token } }
            this.http.post(`${environment.url_api}/blacklistcandidatura/bulk`, listaLogin, this.configHeader).subscribe(
                payload => {
                    resolve(payload)
                }, err => {
                    reject(err.error.message);
                })
        })
    }
}